/* Carriely – kern: lades, zoeken, winkelmand, filters, productkaarten */
(() => {
  'use strict';
  const C = window.Carriely || {};
  const S = C.strings || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const decode = (str) => { const t = document.createElement('textarea'); t.innerHTML = str; return t.value; };
  const FORMAT = decode(C.moneyFormat || '€{{amount_with_comma_separator}}');

  function money(cents) {
    const value = (Number(cents) || 0) / 100;
    const fmt = (dec, th, ds) => { const [i, f] = value.toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (dec ? ds + f : ''); };
    return FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount': return fmt(2, ',', '.');
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        default: return fmt(2, '.', ',');
      }
    });
  }
  function priceHTML(price, compare, badge) {
    const sale = compare > price;
    const pct = sale ? Math.floor(((compare - price) * 100) / compare) : 0;
    let html = `<div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${money(price)}</span>`;
    if (sale) {
      html += `<span class="visually-hidden">Oorspronkelijke prijs</span><s class="price__compare">${money(compare)}</s>`;
      if (badge && pct >= 1) html += `<span class="price__badge">-${pct}%</span>`;
    }
    return `${html}</div>`;
  }
  function toast(msg) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove('is-visible'), 4200);
  }

  /* Lades en zoekvenster */
  const layers = { open: null, last: null };
  function openLayer(el) {
    if (!el) return;
    if (layers.open && layers.open !== el) closeLayer(layers.open, true);
    layers.last = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    layers.open = el;
    const target = $('[data-autofocus]', el) || $('[role="dialog"]', el);
    setTimeout(() => target && target.focus({ preventScroll: true }), 90);
  }
  function closeLayer(el, keep) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (layers.open === el) layers.open = null;
    if (!keep) {
      document.body.classList.remove('is-locked');
      if (layers.last && layers.last.focus) layers.last.focus({ preventScroll: true });
    }
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.drawerOpen);
      if (target) { e.preventDefault(); openLayer(target); }
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeLayer(closer.closest('.drawer, .search-modal')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && layers.open) closeLayer(layers.open); });

  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Voorspellend zoeken */
  const modal = $('[data-search-modal]');
  if (modal) {
    const input = $('[data-search-input]', modal);
    const results = $('[data-ps-results]', modal);
    const defaults = $('[data-ps-default]', modal);
    let ctrl;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; if (defaults) defaults.hidden = false; return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      try {
        const url = `${C.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: ctrl.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const inner = $('[data-ps]', doc);
        results.innerHTML = inner ? inner.innerHTML : '';
        results.hidden = false; if (defaults) defaults.hidden = true;
      } catch (err) { if (err.name !== 'AbortError') results.hidden = true; }
    }, 220);
    if (input) input.addEventListener('input', run);
  }

  /* Winkelmand */
  const drawerEl = () => document.getElementById('cart-drawer');
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.dataset.count = n; });
    $$('[data-cart-label]').forEach((el) => el.setAttribute('aria-label', `Winkelmand (${n})`));
  }
  function sectionIds() {
    const ids = ['cart-drawer'];
    const main = $('[data-main-cart]');
    if (main && main.dataset.sectionId) ids.push(main.dataset.sectionId);
    return ids;
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach((id) => {
      const html = sections[id];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        const fresh = doc.getElementById('cart-drawer');
        const current = drawerEl();
        if (fresh && current) { current.innerHTML = fresh.innerHTML; setCount(fresh.dataset.count || 0); }
      } else {
        const wrap = document.getElementById(`shopify-section-${id}`);
        const fresh = doc.getElementById(`shopify-section-${id}`);
        if (wrap && fresh) wrap.innerHTML = fresh.innerHTML;
      }
    });
  }
  async function refreshCart() {
    try { const res = await fetch(`${C.routes.root}?sections=${sectionIds().join(',')}`); if (res.ok) applySections(await res.json()); } catch (e) { /* stil */ }
  }
  async function addToCart(form, button) {
    const err = $('[data-form-error]', form);
    if (err) { err.hidden = true; err.textContent = ''; }
    if (button) button.classList.add('is-loading');
    try {
      const body = new FormData(form);
      body.append('sections', sectionIds().join(','));
      body.append('sections_url', window.location.pathname);
      const res = await fetch(`${C.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const data = await res.json();
      if (!res.ok || data.status) {
        const msg = data.description || data.message || S.addError;
        if (err) { err.textContent = msg; err.hidden = false; } else toast(msg);
        return;
      }
      applySections(data.sections);
      openLayer(drawerEl());
    } catch (e) {
      if (err) { err.textContent = S.addError; err.hidden = false; } else toast(S.addError);
    } finally { if (button) button.classList.remove('is-loading'); }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form], form[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, e.submitter || $('[type="submit"]', form));
  });
  let queue = Promise.resolve();
  function changeLine(line, quantity) {
    queue = queue.then(async () => {
      [drawerEl(), $('[data-main-cart]')].forEach((el) => el && el.classList.add('is-busy'));
      try {
        const res = await fetch(`${C.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity, sections: sectionIds(), sections_url: window.location.pathname }) });
        const data = await res.json();
        if (!res.ok || data.status) { toast(data.description || data.message || S.changeError); await refreshCart(); return; }
        applySections(data.sections);
        setCount(data.item_count);
      } catch (e) { toast(S.changeError); }
      finally { [drawerEl(), $('[data-main-cart]')].forEach((el) => el && el.classList.remove('is-busy')); }
    });
  }
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const wrap = step.closest('[data-qty]');
      const input = wrap && $('input', wrap);
      if (!input) return;
      const min = input.min !== '' ? Number(input.min) : 0;
      const max = input.max !== '' ? Number(input.max) : Infinity;
      const next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyStep)));
      if (String(next) !== input.value) { input.value = next; input.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    const remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(Number(remove.dataset.lineRemove), 0); return; }
    const sw = e.target.closest('[data-card-swatch]');
    if (sw) {
      e.preventDefault();
      const card = sw.closest('[data-card]');
      const img = card && $('.card__img--primary', card);
      if (img && sw.dataset.image) { if (sw.dataset.srcset) img.srcset = sw.dataset.srcset; else img.removeAttribute('srcset'); img.src = sw.dataset.image; }
      if (card) {
        $$('[data-card-swatch]', card).forEach((s) => s.classList.toggle('is-active', s === sw));
        if (sw.dataset.url) $$('[data-card-link]', card).forEach((a) => { a.href = sw.dataset.url; });
      }
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) changeLine(Number(input.dataset.lineQty), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* Filters en sortering op collectiepagina's */
  class Facets {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      root.addEventListener('change', (e) => {
        if (e.target.matches('[data-sort]')) { this.submit(); return; }
        if (e.target.closest('[data-facets-form]') && e.target.type !== 'number') this.submit();
      });
      root.addEventListener('input', debounce((e) => { if (e.target.type === 'number' && e.target.closest('[data-facets-form]')) this.submit(); }, 700));
      root.addEventListener('submit', (e) => { if (e.target.matches('[data-facets-form]')) { e.preventDefault(); this.submit(); } });
      root.addEventListener('click', (e) => { const a = e.target.closest('a[data-facet-link]'); if (a) { e.preventDefault(); this.load(a.getAttribute('href'), a.closest('.pagination')); } });
    }
    submit() {
      const form = $('[data-facets-form]', this.root);
      const params = new URLSearchParams();
      if (form) new FormData(form).forEach((v, k) => { if (v !== '' && k !== 'sort_by') params.append(k, v); });
      const sort = $('[data-sort]', this.root);
      if (sort && sort.value) params.set('sort_by', sort.value);
      const qs = params.toString();
      this.load(`${window.location.pathname}${qs ? `?${qs}` : ''}`);
    }
    async load(href, scroll) {
      const url = new URL(href, window.location.origin);
      const fetchUrl = new URL(url.toString());
      fetchUrl.searchParams.set('section_id', this.sectionId);
      const main = $('[data-results-wrap]', this.root);
      if (main) main.classList.add('is-loading-results');
      try {
        const res = await fetch(fetchUrl.toString());
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = $('[data-collection]', doc);
        if (!fresh) throw new Error('geen sectie');
        const drawer = $('#facets-drawer', this.root);
        const wasOpen = !!(drawer && drawer.classList.contains('is-open'));
        const state = {};
        $$('details.facet', this.root).forEach((d) => { state[d.dataset.facet] = d.open; });
        this.root.innerHTML = fresh.innerHTML;
        $$('details.facet', this.root).forEach((d) => { if (d.dataset.facet in state) d.open = state[d.dataset.facet]; });
        if (wasOpen) { const nd = $('#facets-drawer', this.root); if (nd) { nd.classList.add('is-open'); nd.setAttribute('aria-hidden', 'false'); layers.open = nd; } }
        window.history.replaceState({}, '', url.pathname + url.search);
        if (scroll) window.scrollTo({ top: this.root.getBoundingClientRect().top + window.scrollY - 40, behavior: 'smooth' });
      } catch (e) { window.location.href = url.toString(); }
    }
  }
  $$('[data-collection]').forEach((root) => new Facets(root));

  /* Aanbevelingen */
  $$('[data-recommendations]').forEach(async (el) => {
    const url = el.dataset.url;
    if (!url) return;
    try {
      const res = await fetch(url);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && $('[data-card]', fresh)) { el.innerHTML = fresh.innerHTML; el.hidden = false; }
    } catch (e) { /* stil */ }
  });

  window.CarrielyUI = { $, $$, money, priceHTML, toast, openLayer, closeLayer, layers };
})();